__webpack_require__.p = "/wse-523-image-markup-lab-2/";